/* eslint-disable no-shadow */
import Immutable from 'seamless-immutable';
import createReducer from '../../helpers/createReducer';
import {
  app as state
} from '../store';

export default createReducer(state, {
  SET_PROJECT: (state, { data }) => Immutable({ ...state, projectId: data }),
  SET_DISTRICT: (state, { data }) => Immutable({ ...state, districtId: data }),
  SET_LANG: (state, { data }) => Immutable({ ...state, lang: data }),
  SET_UUID: (state, { data }) => Immutable({ ...state, uuid: data }),
  SET_RUNS_ON: (state, { data }) => Immutable({ ...state, runsOn: data }),
  SET_ACCOUNT_ID: (state, { data }) => Immutable({ ...state, accountId: data }),
  SET_IS_PREVIEW: (state, { data }) => Immutable({ ...state, isPreview: data }),
  SET_APP_STAGE: (state, { data }) => Immutable({ ...state, appStage: data }),
  SET_APP_VERSION: (state, { data }) => Immutable({ ...state, appVersion: data }),
  SET_MAIN_COLOR: (state, { data }) => Immutable({ ...state, mainColor: data }),
  SET_KIDS_DATA: (state, { data }) => Immutable({ ...state, kidsData: data }),
  SET_WHOLE_APP_DATA: (state, { data }) => Immutable({ ...state, ...data }),
  SET_LM_DATA: (state, { data }) => Immutable({ ...state, learningModulesRedux: data }),
  SET_RR_GAME_ONLY: (state, { data }) => Immutable({ ...state, rrGameOnly: data }),
  SET_APIGW_PREFIX: (state, { data }) => Immutable({ ...state, apiGWPrefix: data }),
  SET_DZ_BRAND_CONFIGS: (state, { data }) => Immutable({ ...state, dzBrandConfigs: data }),
});
